import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [
  {
    id: 'home',
    title: 'Home',
    translate: 'MENU.HOME',
    type: 'item',
    icon: 'home',
    url: 'home'
  },
  {
    id: 'master',
    title: 'Master',
    type: 'collapsible',
    icon: 'settings',
    role: ['Admin','user'],
    children: [
      {
        id: 'siteconfig',
        title: 'Site Config',
        type: 'item',
        role: ['Admin','user'], //? To set multiple role: ['Admin', 'Client']
        icon: 'circle',
        url: 'pages/site-config',
        permission: {
          permission: 'manage_company',
          module: 'Company Management'
        }
      },
      {
        id: 'dashboard',
        title: 'Modules',
        type: 'item',
        role: ['Admin','user'], //? To set multiple role: ['Admin', 'Client']
        icon: 'circle',
        url: 'master/dashboard',
        permission: {
          permission: 'manage_company',
          module: 'Company Management'
        }
      },
      {
        id: 'department',
        title: 'Department',
        type: 'item',
        role: ['Admin','user'], //? To set multiple role: ['Admin', 'Client']
        icon: 'circle',
        url: 'master/department',
        permission: {
          permission: 'view_departments',
          module: 'Department Management'
        }
      },
      {
        id: 'role',
        title: 'Role',
        type: 'item',
        role: ['Admin','user'], //? To set multiple role: ['Admin', 'Client']
        icon: 'circle',
        url: 'master/role',
        permission: {
          permission: 'view_roles',
          module: 'Role Management'
        }
      },
    ]
  },

  {
    id: 'users',
    title: 'Users',
    type: 'item',
    icon: 'users',
    url: 'pages/users/list',
    permission: {
      permission: 'view_users',
      module: 'User Management'
    }
  },
  {
    id: 'customers',
    title: 'Customers',
    type: 'item',
    icon: 'smile',
    url: 'pages/customers',
    role: ['Admin','user'],
    permission: {
      permission: 'view_customers',
      module: 'Customer Management'
    }
  },
  {
    id: 'calls',
    title: 'Calls List',
    type: 'item',
    icon: 'phone-call',
    url: 'pages/calls/list',
    role: ['Admin','user'],
    permission: {
      permission: 'view_calls',
      module: 'Call Management'
    }
  },
  {
    id: 'integration',
    title: 'Api Integration',
    type: 'item',
    icon: 'code',
    role: ['Admin'],
    url: 'pages/calling/integration',
  },

  {
    id: 'user-interface',
    type: 'section',
    title: 'User & Profile',
    icon: 'layers',
    classes: 'navigation-bottom',
    children: [
      {
        id: 'logout',
        title: 'Logout',
        type: 'item',
        icon: 'log-out',
        url: 'pages/logout'
      }
    ]
  },
]
